<section class="layout" *appAuthProtected>
  <section [style.position]="!legacyNavbarEnabled ? 'sticky' : 'relative'" [style.top]="!legacyNavbarEnabled ? '0' : 'auto'" class="layout__header" id="header">
    <app-bs-univ-nav-bar *appAuthProtected 
    class="layout__header__global-nav" 
    [transparent]="navBarTransparent"></app-bs-univ-nav-bar>
  </section>

  <section class="layout__body"
    [class.layout__body--radiance]="!legacyNavbarEnabled"
    [class.layout__body--nav-collapsed]="!legacyNavbarEnabled && !isSideNavExpanded">
    <app-bs-side-nav *ngIf="!legacyNavbarEnabled"
      (expandedChange)="onSideNavExpandedChange($event)">
    </app-bs-side-nav>
    <div id="main-content" tabindex="-1" class="layout__body-content">
      <app-search-widget *ngIf="!legacyNavbarEnabled"
        [resultsMapper]="searchWidgetParameters.resultsMapper"
        [requester]="searchWidgetParameters.requester"
        [isActive]="isRadSearchOpen ? 'true' : 'false'"
        closeOnSelect="true"
        (onSelect)="onSearchSelect($event)"
        (onHide)="onRadHideSearch()"
      ></app-search-widget>
      <div class="layout__body-content-inner">
        <router-outlet></router-outlet>
      </div>
      <div class="layout__footer-push" *ngIf="!legacyNavbarEnabled"></div>
      <ng-container *ngIf="!legacyNavbarEnabled && (displayFooter | async)">
        <div *ngIf="buildVersion" class="layout__copyright-footer">©2022-{{currentYearCopyright}} Illumina, Inc., v{{buildVersion}}, <a href="https://help.basespace.illumina.com/overview/latest-release" target="_blank">Release Notes</a></div>
      </ng-container>
    </div>
  </section>

  <div class="layout__footer-push" *ngIf="legacyNavbarEnabled"></div>
</section>

<ng-container *ngIf="(displayFooter | async) && legacyNavbarEnabled">
  <div *ngIf="buildVersion" class="layout__copyright-footer">©2022-{{currentYearCopyright}} Illumina, Inc., v{{buildVersion}}, <a href="https://help.basespace.illumina.com/overview/latest-release" target="_blank">Release Notes</a></div>
</ng-container>



<rad-spinner
  #spinnerLoader
  class="spinner-loader"
  data-cy="progress-overlay-spinner"
></rad-spinner>
